import { BrowserRouter as Router, Route, Routes, Navigate, Link  } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import './App.css';
import AdminDashboard from './AdminDashboard';
import BlogList from './BlogList';
import BlogPost from './BlogPost';
import Notes from './BibleNotes.js'; // Import notes data
import Doctrines from './Doctrines.js'; // Import doctrines data
import barnabas from './bible_character_studies/barnabas.js'; // Import barnabas character data
import testCharacter from './bible_character_studies/test_character.js'; // Import testCharacter character data
import renderContent from './renderContent.js';
import homePageContent from './homePageContent.js';
import InstitutesTracker from './InstitutesTracker.js';
import BookTracker from './BookTracker.js';
import MemoryGame from './MemoryGame';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { collection, query, where, getDocs } from "firebase/firestore";
import { auth, firestore } from './firebase-config';
import { AuthContext, AuthProvider } from './AuthContext'; // Import AuthContext
import VerseRevision from './VerseRevision.js';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import VerseSearch from './VerseSearch.js';
import CompendiumBuilder from './CompendiumBuilder.js';
import GreekRevisionApp from './greek-revision/components/App';
import GeneralRevisionApp from './general-revision/components/GeneralApp';
import HomePage from './HomePage';
import BibleRebinds from './BibleRebinds';
import GoogleNotesViewer from './GoogleNotesViewer';
import TimelinePage from './timeline/components/TimelinePage';
import MapPage from './map/components/MapPage';
import QuizPage from './quiz/components/QuizPage';
let globalUsername = 'Guest';

const scrollToLowerPage = () => {
  const element = document.getElementById('lower-page');
  element.scrollIntoView({ behavior: 'smooth' });
};

function App() {
  const { loggedInUser } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState('home');
  const [isCharacterDropdownOpen, setIsCharacterDropdownOpen] = useState(false);
  const [isNotesDropdownOpen, setIsNotesDropdownOpen] = useState(false);
  const [isDoctrinesDropdownOpen, setIsDoctrinesDropdownOpen] = useState(false);
  const [selectedCharacter, setSelectedCharacter] = useState(null);
  const [selectedNote, setSelectedNote] = useState(null);
  const [selectedDoctrine, setSelectedDoctrine] = useState(null);
  const [characters] = useState([barnabas, testCharacter]);
  const [darkMode, setDarkMode] = useState(true);
  const [notePassword, setNotePassword] = useState('');
  const [isPasswordPromptVisible, setIsPasswordPromptVisible] = useState(false);
  const [passwordProtectedNote, setPasswordProtectedNote] = useState(null);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const toggleCharacterDropdown = () => {
    setIsCharacterDropdownOpen(!isCharacterDropdownOpen);
    if (!isCharacterDropdownOpen) {
      setIsNotesDropdownOpen(false);
      setIsDoctrinesDropdownOpen(false); // Close doctrines dropdown if opened
    }
  };

  const toggleNotesDropdown = () => {
    setIsNotesDropdownOpen(!isNotesDropdownOpen);
    if (!isNotesDropdownOpen) {
      setIsCharacterDropdownOpen(false);
      setIsDoctrinesDropdownOpen(false); // Close doctrines dropdown if opened
    }
  };

  const toggleDoctrinesDropdown = () => {
    setIsDoctrinesDropdownOpen(!isDoctrinesDropdownOpen);
    if (!isDoctrinesDropdownOpen) {
      setIsCharacterDropdownOpen(false);
      setIsNotesDropdownOpen(false); // Close notes dropdown if opened
    }
  };

  const selectCharacter = (character) => {
    setSelectedCharacter(character);
    setCurrentPage('characterStudy');
    setIsCharacterDropdownOpen(false); // Close the character dropdown after selecting a character
    setTimeout(scrollToLowerPage, 20);
  };

  const handlePasswordSubmit = () => {
    if (passwordProtectedNote.password === notePassword) {
      setSelectedNote(passwordProtectedNote);
      setIsNotesDropdownOpen(false);
      setCurrentPage('noteContent');
      setTimeout(scrollToLowerPage, 20);
      setIsPasswordPromptVisible(false);
      setNotePassword('');
      setPasswordProtectedNote(null);
    } else {
      alert('Incorrect password!');
    }
  };

  const handlePasswordCancel = () => {
    setIsPasswordPromptVisible(false);
    setNotePassword('');
    setPasswordProtectedNote(null);
  };

  const selectNote = (note) => {
    if (note.password) {
      setPasswordProtectedNote(note);
      setIsPasswordPromptVisible(true);
      setIsNotesDropdownOpen(false);
    } else {
      setSelectedNote(note);
      setIsNotesDropdownOpen(false); // Close the notes dropdown after selecting a note
      setCurrentPage('noteContent');
      setTimeout(scrollToLowerPage, 20);
    }
  };

  const selectDoctrine = (doctrine) => {
    setSelectedDoctrine(doctrine);
    setIsDoctrinesDropdownOpen(false); // Close the doctrines dropdown after selecting a doctrine
    setCurrentPage('doctrineContent');
    setTimeout(scrollToLowerPage, 20);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (<AuthProvider>
      <div className={`App ${darkMode ? 'dark-mode' : ''}`}>
        <header className="App-header">
          <div className="header-inner">
            <Link to="/" className="site-title">Saved Clay</Link>
            <button
              className="nav-hamburger"
              onClick={() => setMobileNavOpen(o => !o)}
              aria-label="Toggle navigation"
            >
              {mobileNavOpen ? '✕' : '☰'}
            </button>
            <nav className={`navigation${mobileNavOpen ? ' nav-open' : ''}`}>
              <Link to="/" onClick={() => setMobileNavOpen(false)}><button>Home</button></Link>
              <Link to="/blog" onClick={() => setMobileNavOpen(false)}><button>Blog</button></Link>
              {/* <Link to="/rebinds" onClick={() => setMobileNavOpen(false)}><button>Bible Rebinds</button></Link> */}
              <Link to="/book-tracker" onClick={() => setMobileNavOpen(false)}><button>Book Tracker</button></Link>
              {loggedInUser?.username === "Aaron" && (
                <>
                  <Link to="/admin" onClick={() => setMobileNavOpen(false)}><button>Admin</button></Link>
                  <Link to="/verse-revision" onClick={() => setMobileNavOpen(false)}><button>Revision</button></Link>
                  <Link to="/greek-revision" onClick={() => setMobileNavOpen(false)}><button>Greek Revision</button></Link>
                  <Link to="/general-revision" onClick={() => setMobileNavOpen(false)}><button>General Revision</button></Link>
                  <Link to="/verse-search" onClick={() => setMobileNavOpen(false)}><button>Verse Search</button></Link>
                  <Link to="/google-notes" onClick={() => setMobileNavOpen(false)}><button>Google Notes</button></Link>
                  <Link to="/timeline" onClick={() => setMobileNavOpen(false)}><button>Timeline</button></Link>
                  <Link to="/map" onClick={() => setMobileNavOpen(false)}><button>Map</button></Link>
                  <Link to="/quiz" onClick={() => setMobileNavOpen(false)}><button>Quiz</button></Link>
                  <div className="dropdown">
                    <button className="dropdown-button" onClick={toggleNotesDropdown}>
                      Notes {isNotesDropdownOpen ? '▲' : '▼'}
                    </button>
                    <div className={`dropdown-content ${isNotesDropdownOpen ? 'show' : ''}`}>
                      {Notes.map((note) => (
                        <div key={note.id} onClick={() => { selectNote(note); setMobileNavOpen(false); }} className="dropdown-item">
                          {note.title}
                        </div>
                      ))}
                    </div>
                    <button className="dropdown-button" onClick={toggleDoctrinesDropdown}>
                      Doctrines {isDoctrinesDropdownOpen ? '▲' : '▼'}
                    </button>
                    <div className={`dropdown-content ${isDoctrinesDropdownOpen ? 'show' : ''}`}>
                      {Doctrines.map((doctrine) => (
                        <div key={doctrine.id} onClick={() => { selectNote(doctrine); setMobileNavOpen(false); }} className="dropdown-item">
                          {doctrine.title}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </nav>
          </div>
        </header>

        <div className="container" id="lower-page">
          <Routes>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/post/:id" element={<BlogPost />} />
            {/* <Route path="/rebinds" element={<BibleRebinds />} /> */}
            <Route path="/institutes-tracker" element={<InstitutesTracker username={loggedInUser?.username || 'Guest'} />} />
            <Route path="/book-tracker" element={<BookTracker username={loggedInUser?.username || 'Guest'} />} />
            <Route path="/verse-revision" element={<VerseRevision  />} />
            <Route path="/greek-revision/*" element={<GreekRevisionApp />} />
            <Route path="/general-revision/*" element={<GeneralRevisionApp />} />
            <Route path="/compendium" element={<CompendiumBuilder  />} />
            <Route path="/verse-search" element={<VerseSearch  />} />
            <Route path="/google-notes" element={<GoogleNotesViewer />} />
            <Route path="/timeline" element={<TimelinePage />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="/notes/:id" element={<Notes />} />
            <Route path="/doctrines/:id" element={<Doctrines />} />
            {/* <Route path="/memory-game" element={<MemoryGame />} /> */}
            <Route path="/" element={<HomePage />} />
          </Routes>


          {selectedNote && (
  <div className="note-content-page">
    <h2>{selectedNote.title}</h2>
    {selectedNote.title.includes("Greek") ? (
      shuffleArray(selectedNote.sections).map((section) => (
        <NoteSection
          key={`${selectedNote.id}-${section.id}`}
          displaytitle={section.displaytitle}
          displaydescription={section.displaydescription}
          title={section.title}
          content={section.content}
        />
      ))
    ) : (
      selectedNote.sections.map((section) => (
        <NoteSection
          key={`${selectedNote.id}-${section.id}`}
          displaytitle={section.displaytitle}
          displaydescription={section.displaydescription}
          title={section.title}
          content={section.content}
        />
      ))
    )}
  </div>
)}
          
        
        </div>
      </div>
    
  </AuthProvider>
  );
}
const NoteSection = ({ displaytitle, displaydescription, title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSection = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="note-section">
      {displaytitle && <h3 className="note-display-title">{displaytitle}</h3>}
      {displaydescription && <p className="note-display-description">{displaydescription}</p>}
      <div className="note-section-title" onClick={toggleSection}>
        {title}
      </div>
      {isOpen && (
        <div className="note-section-content active">
          {renderContent(content)}
        </div>
      )}
    </div>
  );
};

// Function to shuffle array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export default App;
